module.exports = __webpack_public_path__ + "img/msbr-248.prt.d8a48f77.jpg";